import React, { useState } from 'react';
import { Bell, Search, Plus, User, HelpCircle, LogOut, X, RefreshCw, Calendar } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import { useNotifications } from '../context/NotificationContext';
import { useSearch } from '../context/SearchContext';
import NotificationCenter from './NotificationCenter';
import './Header.css';

const Header = () => {
  const [showNotifications, setShowNotifications] = useState(false);
  const { searchQuery, handleSearch, searchResults, isSearching, clearSearch, handleResultClick: contextHandleClick } = useSearch();
  const { unreadCount, addNotification } = useNotifications();
  const navigate = useNavigate();

  // Load active staff and user from localStorage
  const activeStaff = JSON.parse(localStorage.getItem('gdt_active_staff') || '{}');
  const activeUser = JSON.parse(localStorage.getItem('gdt_active_user') || '{}');

  const handleLogout = () => {
    localStorage.removeItem('gdt_active_staff');
    localStorage.removeItem('gdt_active_user');
    navigate('/login/staff');
  };

  return (
    <header className="header">
      <div className="header-left">
        <div className="location-info">
          <span className="location-main">{activeStaff?.specialty || activeStaff?.full_name || 'Especialidad'}</span>
          <span className="location-sub">{activeStaff?.type || 'Área Activa'}</span>
        </div>
        
        <div className="omnibar-container">
          <div className="omnibar">
            <Search size={18} className="search-icon" />
            <input 
              type="text" 
              placeholder="Buscar pacientes, turnos, profesionales..." 
              value={searchQuery}
              onChange={(e) => { e.preventDefault(); handleSearch(e.target.value); }}
              onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); } }}
              autoComplete="off"
              name="header-search-input"
            />
            {isSearching && <RefreshCw size={14} className="search-spinner animate-spin" />}
            {searchQuery && !isSearching && <X size={14} className="clear-search" onClick={(e) => { e.preventDefault(); e.stopPropagation(); clearSearch(); }} />}
          </div>

          {searchResults.length > 0 && (
            <div className="search-results-dropdown">
              {searchResults.map(result => (
                <div key={`${result.type}-${result.id}`} className="search-result-item" onClick={(e) => { e.preventDefault(); contextHandleClick(result, navigate); }}>
                  {result.type === 'patient' ? <User size={16} /> : result.type === 'appointment' ? <Calendar size={16} /> : <HelpCircle size={16} />}
                  <div className="result-info">
                    <span className="result-name">{result.title}</span>
                    <span className="result-meta">{result.subtitle}</span>
                  </div>
                  {result.status && <span className={`result-status-badge ${result.status}`}>{result.status}</span>}
                  {result.type === 'appointment' && (
                    <button 
                      className="btn-create-patient-mini"
                      style={{marginLeft:'auto', background:'transparent', border:'1px solid var(--primary-cyan)', color:'var(--primary-cyan)', borderRadius:'4px', padding:'2px 8px', fontSize:'0.75rem', cursor:'pointer'}}
                      onClick={(e) => { 
                        e.stopPropagation(); 
                        clearSearch();
                        navigate('/patients', { state: { createPatient: true, appData: result.appData } });
                      }}
                    >
                      <Plus size={12} style={{display:'inline', marginBottom:'-2px'}} /> CREAR FICHA
                    </button>
                  )}

                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      
      <div className="header-right">
        <div className="header-icons">
          <button className="btn-icon-header" onClick={() => navigate('/help')} title="Ayuda">
            <HelpCircle size={20} />
          </button>
          <button 
            className={`btn-icon-header ${unreadCount > 0 ? 'has-notifications' : ''}`}
            onClick={() => setShowNotifications(!showNotifications)}
            title="Notificaciones"
          >
            <Bell size={20} />
            {unreadCount > 0 && <span className="notification-badge">{unreadCount}</span>}
          </button>
        </div>
        
        <div className="header-user">
          <div className="user-avatar-circle" onClick={() => navigate('/settings')}>
            <User size={20} />
          </div>
          <span className="header-username">{activeUser?.username?.toUpperCase() || 'ADMINISTRADOR'}</span>
          <button className="btn-logout" onClick={handleLogout} title="Salir">
            <LogOut size={16} />
          </button>
        </div>
        

        <NotificationCenter 
          isOpen={showNotifications} 
          onClose={() => setShowNotifications(false)} 
        />
      </div>
    </header>
  );
};

export default Header;
